const initialState = {
  main: []
};

export default function (state = initialState, action) {
  if (action.error) {
    switch (action.payload.name) {
      default:
        const main = state.main.length > 4 ? state.main.slice(1) : state.main;

        let errors;
        if(action.payload.data && action.payload.data.errors){
          errors = action.payload.data.errors;
        }else{
          errors = [{
            message: action.payload.message,
            tags: ['toast'] // tags can be used to filter out errors to show them in different contexts
          }];
        }

        return {
          ...state,
          main: main.concat(errors)
        };
    }
  } else {
    switch (action.type) {
      case 'ROUTE': {
        return {
          main: []
        };
      }
      case 'CLOSE_ERROR': {
        const { payload } = action;
        return {
          main: [
            ...state.main.slice(0, payload.index),
            ...state.main.slice(payload.index + 1),
          ]
        };
      }
      default:
        return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/state/reducers/errors.reducer.js